import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import { useEffect } from "react";
import track from "react-tracking";
import ReactGA from "react-ga4";
import { apiAddUserAction } from "Root/api/apiProfile";
import { withRouter, Route, Switch, Redirect, useLocation, } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "ProfileStyles/main.scss";
import GainfulLoading from "Components/GainfulLoading";
import Zendesk from "react-zendesk";
import toastService from "Root/profile/toastService";
import AccountSettings from "./components/AccountSettings";
import AccountOverview from "./components/AccountOverview";
import { MyProfile, ReferralPage, OrderHistory } from "./components";
import HowToLP from "./components/HowToLP";
import LoadProfileInfoThunk from "./redux/thunkCreators/user/user";
import AdvantagePlan from "./components/AdvantagePlan";
import { Footer } from "../checkout/components/Footer/index";
import SubscriptionPageV2 from "./components/SubscriptionPageV2";
import { LoadOrderStatusDataThunk } from "./redux/thunkCreators/orders/orderDetails";
import { LoadNextOrderDatesThunk } from "./redux/thunkCreators/orders/nextOrderDates";
import GetItNowV2 from "./components/SubscriptionPageV2/GetItNowV2";
import ReactivationConfirm from "./components/ReactivateSubscription/ReactivationConfirm";
import ReferralLP from "./components/ReferralLPV2";
import RdMacroTool from "./components/RdMacroTool";
import ResultPage from "./components/RdMacroTool/ResultPage";
import RDPageV2 from "./components/RDPageV2";
import CancelSubscriptionV2 from "./components/CancelSubscriptionV2";
import ThankYouPage from "./components/ThankYouPage";
import OnboardingPage from "./components/OnboardingPage";
import { setGlobalLoading } from "./redux/actionCreators/makeActionCreator";
import MobileNavigation from "./components/Navigation/MobileNavigation";
import Animation from "./components/Animation/index";
import UpsellPage from "Root/quiz/components/upsell/upsellPage/index";
import posthog from "posthog-js";
import LoadReferalInfoThunk from "./redux/thunkCreators/referalInfo/referalInfo";
import { pageView } from "../helpers/helper";
import { fetchSeasonalPromotion } from "./redux/slices/profileSeasonalPromotionSlice";
import MemberPerkPage from "./components/MemberPerkPage";
import DebugMenu from "Components/DebugMenu";
import PDP from "./components/BYBFlow/PDP";
import ProspreTestPage from "./components/ProspreTestPage";
import ProsprePlanPage from "./components/ProspreFormPage";
import ProspreGroceryPage from "./components/ProspreGroceryPage";
import { useAppStore } from "./lib/store";
import { generateError } from "Root/api/apiRecharge";
const ZENDESK_KEY = "738d73da-8306-4a32-8721-aa97e287d7e1";
export const BASE = "/app";
export const SUBSCRIPTION_PATH = "/subscription";
export const SUBSCRIPTION_V2_PATH = "/subscription-v2";
export const PROFILE_PATH = "/profile";
export const DIETITIAN_PATH = "/dietitian";
export const PRODUCTS_PATH = "/products";
export const REFER_A_FRIEND_PATH = "/refer-a-friend";
export const ORDER_HISTORY_PATH = "/order-history";
export const SETTINGS_PATH = "/settings";
export const GET_IT_NOW_PATH = "/get-it-now";
export const CANCEL_SUBSCRIPTION = "/cancel-subscription";
export const CANCEL_SUBSCRIPTION_V2 = "/cancel-subscription-v2";
export const ADVANTAGE_PLAN = "/advantage-plan";
export const REACTIVATION_PATH = `${BASE}/reactivation/`;
export const REACTIVATION_MODIFY_PATH = `${BASE}/reactivation/modify`;
export const REACTIVATION_SUMMARY_PATH = `${BASE}/reactivation/summary`;
export const ADDON_QUIZ_RESULTS = `${BASE}/reactivation/results`;
export const HOWTOLP = "/howtolp";
export const ACCOUNT_OVERVIEW = "/home";
export const REACTIVATION_CONFIRM = "/reactivation/confirm";
export const RD_TOOL = "/rd-tool/";
export const MACRO_TOOL_RESULTS = "/rd-tool/results/";
export const THANK_YOU = "/thank-you/";
export const ONBOARDING_PAGE = "/onbording-steps";
export const REFERRAL_PATH = "/referral";
export const MEMBER_PERK = "/memberperk/:perkId";
export const BYB_PRODUCT = "/products/:product";
export const PROSPRE_PATH = "/new-meal-plan";
export const PROSPRE_PLAN_PATH = "/my-meal-plan";
export const GROCERY_LIST_PATH = "/grocery-list";
function ProfileRoutes() {
    const path = useLocation().pathname;
    function handleProfileClick(event) {
        const target = event.target;
        const attribute = target.getAttribute("data-profileclick");
        if (attribute !== null) {
            apiAddUserAction("Click", attribute);
        }
    }
    // redux
    const dispatch = useDispatch();
    const { setShopifyProducts, fetchRechargeSubscriberData, fetchRechargeAddress, fetchRechargeSubscriptions, fetchRechargeUpcomingOrder, } = useAppStore();
    const { loading, nav_visibility } = useSelector((state) => state.components);
    const user = useSelector((state) => state.user);
    const fetchShopifyUpcomingOrder = async () => {
        try {
            await fetchRechargeUpcomingOrder();
        }
        catch (error) {
            const e = generateError(error);
            toastService.errorMessage(e);
        }
    };
    const fetchAllData = async () => {
        dispatch(setGlobalLoading(true));
        // TODO: these could be fired at the same time i bet
        await dispatch(LoadProfileInfoThunk());
        await dispatch(LoadNextOrderDatesThunk());
        await dispatch(LoadReferalInfoThunk());
        await dispatch(LoadOrderStatusDataThunk());
        await dispatch(fetchSeasonalPromotion());
        window.addEventListener("click", handleProfileClick);
        dispatch(setGlobalLoading(false));
        apiAddUserAction("Page View", "Profile");
        ReactGA.send({
            hitType: dispatch((data) => data.funComponent),
            page: window.location.pathname + window.location.search,
        });
        apiAddUserAction("Page View", "Profile");
        const promo_error_text = localStorage.getItem("promo_error_text");
        if (promo_error_text !== null) {
            toastService.errorMessage(promo_error_text);
            localStorage.removeItem("promo_error_text");
        }
    };
    const fetchSubscriptions = async () => {
        try {
            await fetchRechargeSubscriptions();
        }
        catch (error) {
            const e = generateError(error);
            toastService.errorMessage(e);
        }
    };
    const fetchSubscriberData = async () => {
        try {
            await fetchRechargeSubscriberData();
        }
        catch (error) {
            const e = generateError(error);
            toastService.errorMessage(e);
        }
    };
    const fetchAddress = async () => {
        try {
            await fetchRechargeAddress();
        }
        catch (error) {
            const e = generateError(error);
            toastService.errorMessage(e);
        }
    };
    useEffect(() => {
        pageView(location.pathname);
    }, [location.pathname]);
    useEffect(() => {
        Promise.all([
            fetchAllData(),
            fetchSubscriptions(),
            fetchSubscriberData(),
            fetchAddress(),
            fetchShopifyUpcomingOrder(),
        ]);
    }, []);
    useEffect(() => {
        if (user.profile_id) {
            posthog?.identify(user.profile_id, {
                email: user.email,
                gender: user.gender,
                user_class: user.user_class,
            });
        }
    }, [user]);
    return (_jsxs(_Fragment, { children: [_jsxs(Switch, { children: [_jsx(Route, { path: `${BASE}/order-history`, component: OrderHistory }), _jsx(Route, { path: BASE + DIETITIAN_PATH, component: RDPageV2 }), _jsx(Route, { path: BASE + SUBSCRIPTION_PATH, component: SubscriptionPageV2 }), user.user_class !== "byb" && (_jsx(Route, { path: BASE + PROFILE_PATH, component: MyProfile })), _jsx(Route, { path: BASE + REFER_A_FRIEND_PATH, component: ReferralPage }), _jsx(Route, { path: BASE + SETTINGS_PATH, component: AccountSettings }), _jsx(Route, { path: BASE + GET_IT_NOW_PATH, component: GetItNowV2 }), _jsx(Route, { path: BASE + CANCEL_SUBSCRIPTION_V2, component: CancelSubscriptionV2 }), _jsx(Route, { path: BASE + ADVANTAGE_PLAN, component: AdvantagePlan }), _jsx(Route, { path: BASE + ACCOUNT_OVERVIEW, component: AccountOverview }), _jsx(Route, { path: BASE + HOWTOLP, component: HowToLP }), _jsx(Route, { path: BASE + REACTIVATION_CONFIRM, component: ReactivationConfirm }), _jsx(Route, { path: BASE + MACRO_TOOL_RESULTS, component: ResultPage }), _jsx(Route, { path: BASE + RD_TOOL, component: RdMacroTool }), _jsx(Route, { path: BASE + THANK_YOU, component: ThankYouPage }), _jsx(Route, { path: BASE + ONBOARDING_PAGE, component: OnboardingPage }), _jsx(Route, { path: BASE + BYB_PRODUCT, component: PDP }), _jsx(Route, { path: BASE + PRODUCTS_PATH, component: UpsellPage }), _jsx(Route, { path: BASE + MEMBER_PERK, component: MemberPerkPage }), _jsx(Route, { path: BASE + REFERRAL_PATH, component: ReferralLP }), _jsx(Route, { path: BASE + PROSPRE_PATH, component: ProspreTestPage }), _jsx(Route, { path: BASE + PROSPRE_PLAN_PATH, component: ProsprePlanPage }), _jsx(Route, { path: BASE + GROCERY_LIST_PATH, component: ProspreGroceryPage }), _jsx(Route, { path: "/app/animation/", component: Animation }), _jsx(Route, { render: () => _jsx(Redirect, { to: "/app/home" }) })] }), loading && _jsx(GainfulLoading, {}), _jsx(Zendesk, { defer: true, zendeskKey: ZENDESK_KEY }), !path.includes(CANCEL_SUBSCRIPTION) && !path.includes("memberperk") && (_jsx(Footer, { profileFooter: true, userLoggedIn: true })), !path.includes("memberperk") && _jsx(MobileNavigation, {}), _jsx(DebugMenu, {})] }));
}
const TrackedProfileApp = track({ Component: "Profile_app" }, {
    dispatch: (data) => {
        ReactGA.event({
            category: data.funComponent,
            action: data.event,
        });
    },
})(withRouter(ProfileRoutes));
export default TrackedProfileApp;
